<div class="frame-size-page">
  <div class="header">
    <div class="title">Select frame size to test</div>
  </div>
  <div class="edit-frame-body">
    <div class="strmFrameSelectContainer">
      <div class="enable-section" *ngIf="data['multiSelectFrames'] && data['configTestEnable']">
        <mat-slide-toggle
          name="enable"
          class="enable-row"
          color="primary"
          [(ngModel)]="isMultiSelectFrameEnabled"
          (ngModelChange)="onConfigToggleChange()"
          >Use multiple frame sizes for configuration test
        </mat-slide-toggle>
      </div>
      <table class="strmFrameSelectTable">
        <ng-container *ngIf="data['configTestEnable']">
          <tr id="sctOptions" *ngIf="isMultiSelectFrameEnabled">
            <td class="frame-title">
              <img class="icon" [attr.src]="'images/SCTIcon.svg'" /> Configuration
            </td>
            <th
              class="frames-list"
              *ngFor="let frame of selectedSctFramesList; let sctFrameIndex = index"
            >
              {{ frame.label }}
            </th>
          </tr>
          <tr id="sctOptions" *ngIf="isMultiSelectFrameEnabled">
            <td class="toggle-all" (click)="onselectToggleAll()">toggle all</td>
            <th
              class="frames-list"
              *ngFor="let frame of selectedSctFramesList; let sctFrameIndex = index"
            >
              <i
                data-frame="frame.value"
                [ngClass]="frame.enable ? enabledIcon : disabledIcon"
                (click)="onSelectSctFrame(frame.enable, sctFrameIndex)"
              >
              </i>
            </th>
          </tr>
          <tr *ngIf="isMultiSelectFrameEnabled && selectedVlans !== 0">
            <td class="vlan-adjusted frame-title">VLAN Adjusted</td>
            <td class="vlan-adjusted" *ngFor="let frame of sctVlanAdjustedFramesList">
              {{ frame }}
            </td>
          </tr>
          <tr *ngIf="isMultiSelectFrameEnabled">
            <td
              [attr.colspan]="
                selectedSptFramesList?.[selectedSptFramesList?.length - 1]['label'] === 'EMIX'
                  ? selectedSctFramesList?.length - 1
                  : selectedSctFramesList?.length
              "
            ></td>
            <td>
              <div class="custom-frame">
                <input
                  id="strmCustomFrameSize"
                  class="custom-input"
                  type="text"
                  [(ngModel)]="sctCustomFrame"
                  (ngModelChange)="SelectSctCustomFrame()"
                  maxlength="5"
                />
                <mat-error
                  class="error"
                  *ngIf="sctCustomFrame < minValue || sctCustomFrame > maxValue"
                  >Valid range is {{ minValue }}-{{ maxValue }}</mat-error
                >
              </div>
            </td>
            <td *ngIf="data['emixFrames']">
              <mat-form-field class="chip-list" appearance="fill">
                <mat-chip-list #chipList aria-label="frame selection">
                  <mat-chip
                    *ngFor="let frame of selectedSctEmixFrames"
                    (removed)="removeSctEmixFrame(frame)"
                  >
                    {{ frame }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    #sctFrameSizeInput
                    [formControl]="sctFrameSizeCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addSctEmixFrames($event)"
                  />
                </mat-chip-list>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="selectSctEmixFrame($event)"
                >
                  <mat-option *ngFor="let frame of filteredSptFrames | async" [value]="frame">
                    {{ frame }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-error
                class="error min-max-error"
                *ngIf="selectedSctEmixFrames?.length < 2 && !minMaxSctFramesMsg"
                >You must select at least 2 frames sizes
              </mat-error>
              <mat-error
                class="error min-max-error"
                *ngIf="selectedSctEmixFrames?.length >= 8 && !minMaxSctFramesMsg"
                >Maximum number of Frames has been reached
              </mat-error>
              <mat-error
                class="error min-max-error"
                *ngIf="minMaxSctFramesMsg && selectedSctEmixFrames?.length < 8"
                >Valid frame size range is {{ minValue }}-{{ maxValue }}
              </mat-error>
            </td>
          </tr>
        </ng-container>
        <tr id="sptOptions" *ngIf="isMultiSelectFrameEnabled && data['performanceTestEnable']">
          <td
            class="frame-title"
            *ngIf="isMultiSelectFrameEnabled && data['performanceTestEnable']"
          >
            <img class="icon" [attr.src]="'images/SPTIcon.svg'" />Performance
          </td>
          <td class="frame-title" *ngIf="!isMultiSelectFrameEnabled">Frame size</td>
          <th class="frames-list" *ngFor="let frame of selectedSptFramesList">{{ frame.label }}</th>
        </tr>
        <tr id="sptOptions" *ngIf="isMultiSelectFrameEnabled && data['performanceTestEnable']">
          <td
            *ngIf="data['multiSelectFramesEnabled']"
            class="toggle-all"
            (click)="onselectToggleAll()"
          >
            Toggle all
          </td>
          <td *ngIf="!data['multiSelectFramesEnabled']" class="frame-title"></td>
          <th
            class="frames-list"
            *ngFor="let frame of selectedSptFramesList; let sptFrameIndex = index"
          >
            <i
              data-frame="frame.value"
              [ngClass]="frame.enable ? enabledIcon : disabledIcon"
              (click)="onSelectSptFrame(frame.enable, sptFrameIndex)"
            >
            </i>
          </th>
        </tr>
        <tr
          *ngIf="selectedVlans !== 0 && isMultiSelectFrameEnabled && data['performanceTestEnable']"
        >
          <td class="vlan-adjusted frame-title">VLAN Adjusted</td>
          <td class="vlan-adjusted" *ngFor="let frame of sptVlanAdjustedFramesList">{{ frame }}</td>
        </tr>
        <tr *ngIf="isMultiSelectFrameEnabled && data['performanceTestEnable']">
          <td
            [attr.colspan]="
              selectedSptFramesList?.[selectedSptFramesList?.length - 1]['label'] === 'EMIX'
                ? selectedSptFramesList?.length - 1
                : selectedSptFramesList?.length
            "
          ></td>
          <td>
            <div class="custom-frame">
              <input
                id="strmCustomSptFrameSize"
                class="custom-input"
                type="text"
                [(ngModel)]="sptCustomFrame"
                (ngModelChange)="SelectSptCustomFrame()"
                maxlength="5"
              />
              <mat-error
                class="error"
                *ngIf="sptCustomFrame < minValue || sptCustomFrame > maxValue"
                >Valid range is {{ minValue }}-{{ maxValue }}</mat-error
              >
            </div>
          </td>
          <td *ngIf="data['emixFrames']">
            <mat-form-field class="chip-list" appearance="fill">
              <mat-chip-list #chipList aria-label="frame selection">
                <mat-chip
                  *ngFor="let frame of selectedSptEmixFrames"
                  (removed)="removeSptEmixFrame(frame)"
                >
                  {{ frame }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  #sptFrameSizeInput
                  [formControl]="sptFrameSizeCtrl"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addSptEmixFrames($event)"
                />
              </mat-chip-list>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selectSptEmixFrame($event)"
              >
                <mat-option *ngFor="let frame of filteredSptFrames | async" [value]="frame">
                  {{ frame }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-error
              class="error min-max-error"
              *ngIf="selectedSptEmixFrames?.length < 2 && !minMaxSptFramesMsg"
              >You must select at least 2 frames sizes
            </mat-error>
            <mat-error
              class="error min-max-error"
              *ngIf="selectedSptEmixFrames?.length >= 8 && !minMaxSptFramesMsg"
              >Maximum number of Frames has been reached
            </mat-error>
            <mat-error
              class="error min-max-error"
              *ngIf="minMaxSptFramesMsg && selectedSptEmixFrames?.length < 8"
              >Valid frame size range is {{ minValue }}-{{ maxValue }}
            </mat-error>
          </td>
        </tr>
        <tr id="sptOptions" *ngIf="!isMultiSelectFrameEnabled">
          <td class="frame-title" *ngIf="!isMultiSelectFrameEnabled">Frame size</td>
          <th class="frames-list" *ngFor="let frame of selectedSptFramesList">{{ frame.label }}</th>
        </tr>
        <tr id="sptOptions" *ngIf="!isMultiSelectFrameEnabled">
          <td
            *ngIf="data['multiSelectFramesEnabled']"
            class="toggle-all"
            (click)="onselectToggleAll()"
          >
            Toggle all
          </td>
          <td *ngIf="!data['multiSelectFramesEnabled']" class="frame-title"></td>
          <th
            class="frames-list"
            *ngFor="let frame of selectedSptFramesList; let sptFrameIndex = index"
          >
            <i
              data-frame="frame.value"
              [ngClass]="frame.enable ? enabledIcon : disabledIcon"
              (click)="onSelectSptFrame(frame.enable, sptFrameIndex)"
            >
            </i>
          </th>
        </tr>
        <tr *ngIf="selectedVlans !== 0 && !isMultiSelectFrameEnabled">
          <td class="vlan-adjusted frame-title">VLAN Adjusted</td>
          <td class="vlan-adjusted" *ngFor="let frame of sptVlanAdjustedFramesList">{{ frame }}</td>
        </tr>
        <tr *ngIf="!isMultiSelectFrameEnabled">
          <td
            [attr.colspan]="
              selectedSptFramesList?.[selectedSptFramesList?.length - 1]['label'] === 'EMIX'
                ? selectedSptFramesList?.length - 1
                : selectedSptFramesList?.length
            "
          ></td>
          <td>
            <div class="custom-frame">
              <input
                id="strmCustomSptFrameSize"
                class="custom-input"
                type="text"
                [(ngModel)]="sptCustomFrame"
                (ngModelChange)="SelectSptCustomFrame()"
                maxlength="5"
              />
              <mat-error
                class="error"
                *ngIf="sptCustomFrame < minValue || sptCustomFrame > maxValue"
                >Valid range is {{ minValue }}-{{ maxValue }}</mat-error
              >
            </div>
          </td>
          <td *ngIf="data['emixFrames']">
            <mat-form-field class="chip-list" appearance="fill">
              <mat-chip-list #chipList aria-label="frame selection">
                <mat-chip
                  *ngFor="let frame of selectedSptEmixFrames"
                  (removed)="removeSptEmixFrame(frame)"
                >
                  {{ frame }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  #sptFrameSizeInput
                  [formControl]="sptFrameSizeCtrl"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addSptEmixFrames($event)"
                />
              </mat-chip-list>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selectSptEmixFrame($event)"
              >
                <mat-option *ngFor="let frame of filteredSptFrames | async" [value]="frame">
                  {{ frame }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-error
              class="error min-max-error"
              *ngIf="selectedSptEmixFrames?.length < 2 && !minMaxSptFramesMsg"
              >You must select at least 2 frames sizes
            </mat-error>
            <mat-error
              class="error min-max-error"
              *ngIf="selectedSptEmixFrames?.length >= 8 && !minMaxSptFramesMsg"
              >Maximum number of Frames has been reached
            </mat-error>
            <mat-error
              class="error min-max-error"
              *ngIf="minMaxSptFramesMsg && selectedSptEmixFrames?.length < 8"
              >Valid frame size range is {{ minValue }}-{{ maxValue }}
            </mat-error>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div>
    <div class="btn-group add-device">
      <button
        mat-flat-button
        class="save-btn"
        [disabled]="isValidFrameSelection()"
        (click)="saveFrameSelection()"
      >
        SAVE
      </button>
      <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
    </div>
  </div>
</div>
